import {Stack, List, ListItem, ListItemButton, Typography} from '@mui/material'
import RpIcon from "@/components/RpIcon";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import React, {useMemo, useState} from "react";
import dayjs from "dayjs";
import {useTranslation} from "react-i18next";
import {useBoolean, useRequest} from "ahooks";
import {exportBill} from "@/services/card";
import {getUrlParams} from "@/utils/utils";
import {enqueueSnackbar} from "notistack";
import {useSelector} from "react-redux";
import AppModal from "@/components/AppModal.tsx";
import AppDatePicker from "@/components/AppDatePicker";
import AppLoadingButton from '@/components/mui/LoadingButton';

const getTimeDisplay = (value: number) => {
  let ret = ''
  switch (value) {
    case 1:
      ret = dayjs().format('YYYY-MM')
      break
    case 2:
      let lastMonth = dayjs().add(-1, 'month').format('YYYY-MM')
      ret = lastMonth
      break
    case 3:
      ret = `${dayjs().format('YYYY-MM')}~${dayjs().add(-3, 'month').format('YYYY-MM')}`
      break
    case 4:
      ret =  dayjs().format('YYYY')
      break
    case 5:
      ret = dayjs().add(-1, 'year').format('YYYY')
      break
    case 6:
      ret = dayjs().add(-1, 'year').format('YYYY')
      break
  }
  return ret
}

const options = [
  { label: 'this_month', value: 1, timeDisplay: getTimeDisplay(1) },
  { label: 'last_month', value: 2, timeDisplay: getTimeDisplay(2) },
  { label: 'last_3_month', value: 3, timeDisplay: getTimeDisplay(3) },
  { label: 'this_year', value: 4, timeDisplay: getTimeDisplay(4) },
  { label: 'last_year', value: 5, timeDisplay: getTimeDisplay(5) },
  { label: 'customize', value: 6, timeDisplay: getTimeDisplay(6) },
]

const DownloadBill = () => {
  const card_id = getUrlParams('card_id')
  const {t} = useTranslation();
  const [selectedIndex, setSelectedIndex] = React.useState(-1);
  const { user } = useSelector(state => state.user);

  const [startMonth, setStartMonth] = React.useState('');
  const [endMonth, setEndMonth] = React.useState('');
  const [customMonthModal, customMonthModalOperate] = useBoolean(false)
  const selectedOption = useMemo(() => {
    return options[selectedIndex]
  }, [selectedIndex])
  const downloadBllReq = useRequest(async () => {
    let postData = {}
    if (selectedOption.value == 1) {
      postData = {
        cardId: card_id,
        ...postData,
        startMonth: dayjs().format('YYYY-MM'),
        endMonth: dayjs().format('YYYY-MM')
      }
    }
    if (selectedOption.value == 2) {
      postData = {
        cardId: card_id,
        ...postData,
        startMonth: dayjs().add(-1, 'month').format('YYYY-MM'),
        endMonth: dayjs().add(-1, 'month').format('YYYY-MM')
      }
    }
    if (selectedOption.value == 3) {
      postData = {
        cardId: card_id,
        ...postData,
        startMonth: dayjs().add(-3, 'month').format('YYYY-MM'),
        endMonth: dayjs().format('YYYY-MM')
      }
    }

    if (selectedOption.value == 4) {
      postData = {
        cardId: card_id,
        ...postData,
        startMonth: dayjs().startOf('year').format('YYYY-MM'),
        endMonth: dayjs().endOf('year').format('YYYY-MM')
      }
    }
    if (selectedOption.value == 5) {
      postData = {
        cardId: card_id,
        ...postData,
        startMonth: dayjs().add(-1, 'year').startOf('year').format('YYYY-MM'),
        endMonth: dayjs().add(-1, 'year').endOf('year').format('YYYY-MM')
      }
    }
    if (selectedOption.value == 6) {
      postData = {
        cardId: card_id,
        ...postData,
        startMonth: dayjs(startMonth).format('YYYY-MM'),
        endMonth: dayjs(endMonth).format('YYYY-MM')
      }
    }
    const res = await exportBill(postData)
    return res
  }, { manual: true })
  const handleConfirmCustomDate=()=>{
    if(!startMonth || !endMonth){
      enqueueSnackbar(t('custom_date_null'), { variant: 'error',autoHideDuration:1500 })
      return false
    }else{
      const start = dayjs(startMonth)
      const end = dayjs(endMonth)
      const isBefore = start.isBefore(end)
      if(!isBefore){
        enqueueSnackbar(t('custom_date_error'), { variant: 'error',autoHideDuration:1500 })
        return false
      }
    }
    customMonthModalOperate.setFalse()
  }
  return (<>
    <Stack direction="column" sx={{width: '100%', flex: 1}}>
      <SimpleHeader title={t('bill_statement')}

      />
      <Stack sx={{flex: 1}} justifyContent="space-between" direction="column">
        <List dense sx={{ width: '100%' }}>
          {
            options.map((item, index) => {
              return (<>
                <ListItem
                  sx={{ marginBottom: '24px' }}
                  key={item.value}
                onClick={() => {
                  if (index == 5) {
                    customMonthModalOperate.setTrue()
                  }
                  setSelectedIndex(index);
                }}
                >
                  <Stack sx={{width: '100%'}} direction="row" justifyContent="space-between">
                    <Stack>
                      <Typography>{t(item.label)}</Typography>
                      {index < 5 && <Typography>{item.timeDisplay}</Typography>}
                      {(index >= 5 && (startMonth && endMonth)) && <Typography>{`${dayjs(startMonth).format('YYYY-MM')}~${dayjs(endMonth).format('YYYY-MM')}`}</Typography>}
                    </Stack>
                    {selectedIndex == index && <RpIcon icon="check-circle-full" size={24} />}
                  </Stack>
                </ListItem>
              </>)
            })
          }
        </List>
        <Stack gap={'8px'} direction="column" alignItems="center" sx={{padding: '0 16px'}}>
          <AppLoadingButton
            size='large'
            loading={downloadBllReq.loading}
            fullWidth
            onClick={() => {
              downloadBllReq.runAsync().then(res => {
                if (res != null && res['total'] == 0) {
                  enqueueSnackbar(t('bill_empty'), { variant: 'error' })
                  return;
                }
                enqueueSnackbar(t('bill_export_success'), { variant: 'success' });
              })
            }}
            disabled={selectedIndex <= -1}
            variant="contained">{t('export_bill')}</AppLoadingButton>
          <Typography>{t('bill_will_be_sent_to')} {user?.email}</Typography>
        </Stack>
      </Stack>
    </Stack>
    <AppModal
      open={customMonthModal}
      onClose={customMonthModalOperate.setTrue}
    >
      <Stack sx={{padding: '16px'}}>
        <Stack direction="row" justifyContent="space-between">
          <RpIcon
            clickable
            onClick={() => {
              customMonthModalOperate.setFalse()
            }}
            icon="arrow-left" size={22} />
          <Typography sx={{flex: 1, textAlign: 'center'}}>{t('customize')}</Typography>
        </Stack>
        <Stack sx={{marginTop: '24px'}} direction="row" gap="16px" justifyContent="space-between" alignItems="center">
          <AppDatePicker
            name="startTime"
            size="small"
            variant="outlined"
            onChange={(date) => setStartMonth(date)}
            onBlur={(date) => setStartMonth(date)}
            add
            value={startMonth}
            input
            slots={{
              openPickerIcon: () => <RpIcon icon="calendar" size={16}/>,
            }}
          />
          <span className="px-2">{t("to")}</span>

          <AppDatePicker
            name="endTime"
            size="small"
            variant="outlined"
            onChange={(date) => setEndMonth(date)}
            onBlur={(date) => setEndMonth(date)}
            add
            value={endMonth}
            input
            slots={{
              openPickerIcon: () => <RpIcon icon="calendar" size={16}/>,
            }}
            renderI
          />
        </Stack>
        <AppLoadingButton
          onClick={handleConfirmCustomDate}
          sx={{marginTop: '24px'}}
          variant="contained" fullWidth>{t('confirm')}</AppLoadingButton>
      </Stack>

    </AppModal>
  </>)
}

export default DownloadBill;